export default {"src":"/_next/static/media/SGFlag.79f62e23.svg","height":24,"width":32};